import React from 'react';
import { Box, Typography, Stack, TextField, Autocomplete } from '@mui/material';
import type { ServiceType } from '../../../../../../services/ConfigurationService/types';

interface ServiceInfoSectionProps {
  selectedService: ServiceType | null;
  serviceCode: string;
  serviceDescription: string;
  description: string;
  services: ServiceType[];
  isDisabled: boolean;
  onServiceChange: (service: ServiceType | null) => void;
  onDescriptionChange: (value: string) => void;
}

export const ServiceInfoSection: React.FC<ServiceInfoSectionProps> = ({
  selectedService,
  serviceCode,
  serviceDescription,
  description,
  services,
  isDisabled,
  onServiceChange,
  onDescriptionChange
}) => {
  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: '#1e293b' }}>
        Service Information
      </Typography>
      <Stack spacing={2}>
        <Autocomplete
          options={services}
          getOptionLabel={(option) => `${option.code} - ${option.description}`}
          value={selectedService}
          onChange={(_, newValue) => onServiceChange(newValue)}
          disabled={isDisabled}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Service"
              size="small"
              placeholder="Select a service..."
              disabled={isDisabled}
              sx={{
                '& .MuiInputBase-input': {
                  backgroundColor: isDisabled ? '#f5f5f5' : 'inherit'
                }
              }}
              helperText={isDisabled ? 'Read-only (Encounter Cancelled)' : ''}
            />
          )}
        />
        <Stack direction="row" spacing={2}>
          <TextField
            label="Service Code"
            size="small"
            value={serviceCode}
            sx={{ flex: 1 }}
            InputProps={{ readOnly: true }}
            helperText="Auto-filled from service selection"
            disabled
          />
          <TextField
            label="Service Description"
            size="small"
            value={serviceDescription}
            sx={{ flex: 2 }}
            InputProps={{ readOnly: true }}
            helperText="Auto-filled from service selection"
            disabled
          />
        </Stack>
        <TextField
          label="Description"
          size="small"
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          disabled={isDisabled}
          fullWidth
          multiline
          rows={2}
          helperText={isDisabled ? 'Read-only (Encounter Cancelled)' : 'Optional service description'}
          sx={{
            '& .MuiInputBase-input': {
              backgroundColor: isDisabled ? '#f5f5f5' : 'inherit'
            }
          }}
          InputProps={{
            sx: {
              alignItems: 'flex-start',
              '& .MuiInputBase-input': {
                paddingTop: '8px'
              }
            }
          }}
        />
      </Stack>
    </Box>
  );
};
